import React, { useState, useEffect } from 'react'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ApproveProposalWidget from '../../../widgets/approveProposalWidget/ApproveProposalWidget'

// Use ApproveProject instead
export default function ApproveProposal() {
  const mockSchemas = {
    header: 'ขั้นที่ 3 พิจารณาอนุมัติโครงการ',
    subHeader: 'ข้อเสนอโครงการ ปิดเทอมสร้างสรรค์ และกิจกรรมสร้างเสริมสุขภาพ สำหรับเด็กและ เยาวชน',
  }

  const schema = {
    headerApproveProposal: 'พิจารณาอนุมัติทุน',
    alert: 'งบประมาณที่ขอไม่สอดคล้องกับแผนการจัดสรรงบประมาณของ สสส.',
    remark: {
      name: 'remark',
      label: 'หมายเหตุ',
      value: '',
    },
    approveProposal: {
      name: 'approveProposal',
      value: 1,
      options: [
        {
          label: 'อนุมัติทุน',
          value: 1,
        },
        {
          label: 'อนุมัติทุน (มีการแก้ไข)',
          value: 2,
        },
        {
          label: 'ไม่อนุมัติทุน',
          value: 3,
        },
      ],
      validators: [
        {
          type: 'REQUIRED',
          errorMessage: 'กรุณาเลือก',
        },
      ],
    },
    buttonApproveProposalLabel: 'บันทึกผลอนุมัติ',
  }

  return (
    <SidebarProposal>
      <ContentHeader header={mockSchemas.header} subHeader={mockSchemas.subHeader} />

      <ApproveProposalWidget schema={schema} />
      <br />
    </SidebarProposal>
  )
}
